export const CEO_THEMES = [
  { id: "executive-white", label: "Executive White", description: "White workspace · navy navigation" },
  { id: "executive-violet", label: "Executive Violet", description: "Bright surfaces · violet signal" },
  { id: "ocean-command", label: "Ocean Command", description: "Deep navy · teal data" },
  { id: "midnight-emerald", label: "Midnight Emerald", description: "Charcoal · emerald actions" },
];

export const DEFAULT_CEO_THEME = "executive-white";
export const CEO_THEME_STORAGE_KEY = "universe:ceo-theme";

export function normalizeCEOTheme(value) {
  return CEO_THEMES.some((theme) => theme.id === value)
    ? value
    : DEFAULT_CEO_THEME;
}
